/*!
=========================================================
* Muse Ant Design Dashboard - v1.0.0
=========================================================
* Product Page: https://www.creative-tim.com/product/muse-ant-design-dashboard
* Copyright 2021 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/muse-ant-design-dashboard/blob/main/LICENSE.md)
* Coded by Creative Tim
=========================================================
* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
import React from "react";
import { createRoot } from "react-dom/client";

import AppRoute from "./AppRoute";

const root: HTMLElement | null = document.getElementById("root");
if (root) {
  const rootElement = createRoot(root);
  rootElement.render(<AppRoute />);
}
